export function trackStep(quiz, question, stepNumber, totalSteps) {
  const quizId = quiz.tracking_id || quiz.title || "Product Finder";

  trackEvent("Product Finder Step", {
    event_category: "Product Finder",
    event_label: quizId,
    quiz_id: quizId,
    quiz_title: quiz.title || "",
    question_id: question.id || "",
    question_text: question.question || "",
    step_number: stepNumber,
    total_steps: totalSteps,
  });
}

function trackEvent(action, params) {
  if (typeof window.gtag !== "function") {
    return;
  }

  window.gtag("event", action, params);
}
